const menuItems = document.querySelectorAll(".hypper-link-menu--item a");
const sections = document.querySelectorAll("section");
let isScrolling = false;
let scrollTimeout;

function setActiveMenuItem(index, indexable) {
  // if (indexable) {
  //   index = index - 1;
  // }
  menuItems.forEach((item) => item.classList.remove("active"));
  menuItems[index]?.classList.add("active");
  if (menuItems[index]) {
    const tabRect = menuItems[index].getBoundingClientRect();
    if (tabRect.right > window.innerWidth || tabRect.left < 0) {
      menuItems[index].scrollIntoView({
        behavior: "smooth",
        block: "start",
        inline: "nearest",
      });
    }
  }
}

function handleMenuItemClick(event) {
  event.preventDefault();
  const targetSection = document.querySelector(
    event.currentTarget.getAttribute("href")
  );
  // const headerHeight = parseInt(getComputedStyle(document.documentElement).getPropertyValue('--header-height'));
  const hyperLinkmenu = parseInt(
    getComputedStyle(document.documentElement).getPropertyValue(
      "--hyperlink-menu-height"
    )
  );

  const targetPositionn = targetSection.offsetTop;
  const targetPosition = targetSection.offsetTop - hyperLinkmenu;
  isScrolling = true;

  window.scrollTo({
    top: targetPosition,
    behavior: "smooth",
  });

  setActiveMenuItem(Array.from(menuItems).indexOf(event.currentTarget), false);

  setTimeout(() => {
    isScrolling = false;
  }, 1000); // Adjust the delay as needed
}

menuItems.forEach((menuItem) => {
  menuItem.addEventListener("click", (event) => {
    if (!isScrolling) {
      handleMenuItemClick(event);
    }
  });
});

window.addEventListener("scroll", () => {
  clearTimeout(scrollTimeout);
  scrollTimeout = setTimeout(() => {
    if (!isScrolling) {
      const currentPosition = window.scrollY;

      sections.forEach((section, index) => {
        const sectionTop = section.offsetTop - 50;
        const sectionBottom = sectionTop + section.offsetHeight;
        if (currentPosition >= sectionTop && currentPosition < sectionBottom) {
          setActiveMenuItem(index - 1, true);
        }
      });
    }
  }, 100); // Adjust the debounce time as needed
});
setActiveMenuItem(0, true);
